import { slides } from './config.json';
import Empty from './Empty.vue';

const components = [];
slides.forEach(slideName => {
  let left, right;
  try {
    left = require(`./Slides/${slideName}/Left.vue`) || Empty;
  } catch (e) {
    left = Empty;
  }
  try {
    right = require(`./Slides/${slideName}/Right.vue`) || Empty;
  } catch (e) {
    right = Empty;
  }
  components.push({ left, right });
});

export const getSlide = (index, animationDirection = 'left') => {
  if (!components[index] || !components[index][animationDirection]) {
    return null;
  }
  return components[index][animationDirection].default;
};

export const getCount = () => components.length;



// WEBPACK FOOTER //
// ./src/components/SlideFragment/index.js